var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTs44(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 214.73106,
    height: 500,
    viewBox: "0 0 56.814256 132.29165",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-1.2017345e-4,-164.7083)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 36.777084,
    y: 111.2625,
    id: "text12"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan14",
    x: 36.777084,
    y: 121.05208
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 66.410416,
    y: 130.04791,
    id: "text18"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan16",
    x: 66.410416,
    y: 139.83749,
    style: {
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1D2",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "360.46774292px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 9.011693
    },
    id: "text22"
  }, /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1F1\\uE201  \\uE1F1\\uE202   \\uE1F1\\uE203",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2.38434362
    },
    id: "text4452",
    transform: "matrix(10.656437,0,0,10.656497,-222.74223,-2175.8406)"
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uF5EC",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2.38434362
    },
    id: "text4548",
    transform: "matrix(15.605456,0,0,15.605456,-23.289002,-3008.3021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 4.3922042,206.0786 v -1.80975 c 0,-0.0635 -0.010583,-0.14817 -0.1058333,-0.14817 -0.074083,0 -0.1164167,0.0212 -0.1693334,0.0847 l -0.8043333,0.97367 c -0.03175,0.0423 -0.074083,0.0847 -0.074083,0.1905 v 0.70908 h -1.143 c 0.6773333,-0.5715 2.032,-2.49767 2.0531666,-2.59292 0,-0.0106 0.010583,-0.0212 0.010583,-0.0423 0,-0.0635 -0.0635,-0.11642 -0.127,-0.11642 -0.074083,0 -0.4233333,0.0212 -0.5715,0.0212 -0.15875,0 -0.53975,-0.0212 -0.60325,-0.0212 -0.074083,0 -0.2010833,0.0317 -0.2010833,0.15875 0,1.05834 -0.8255,2.23309 -1.0795,2.58234 l -0.052917,0.0741 c 0,0.0106 -0.010583,0.0106 -0.010583,0.0212 -0.010583,0.0317 -0.021167,0.0741 -0.021167,0.0952 0,0.0847 0.0635,0.14816 0.1693333,0.14816 h 1.5769166 v 0.52917 c 0,0.23283 -0.1905,0.29633 -0.3386667,0.29633 -0.1375833,0 -0.2010833,0.0741 -0.2010833,0.15875 0,0.0847 0.042333,0.17992 0.1693333,0.17992 h 1.7991667 c 0.084667,0 0.1693333,-0.0635 0.1693333,-0.17992 0,-0.11641 -0.1058333,-0.16933 -0.1905,-0.16933 -0.084667,0 -0.254,-0.0529 -0.254,-0.3175 v -0.49742 H 5.006037 c 0.084667,0 0.127,-0.0635 0.127,-0.16933 0,-0.0952 -0.03175,-0.15875 -0.127,-0.15875 z m 0,4.23333 v -1.80975 c 0,-0.0635 -0.010583,-0.14816 -0.1058333,-0.14816 -0.074083,0 -0.1164167,0.0212 -0.1693334,0.0847 l -0.8043333,0.97367 c -0.03175,0.0423 -0.074083,0.0847 -0.074083,0.1905 v 0.70908 h -1.143 c 0.6773333,-0.5715 2.032,-2.49766 2.0531666,-2.59291 0,-0.0106 0.010583,-0.0212 0.010583,-0.0423 0,-0.0635 -0.0635,-0.11641 -0.127,-0.11641 -0.074083,0 -0.4233333,0.0212 -0.5715,0.0212 -0.15875,0 -0.53975,-0.0212 -0.60325,-0.0212 -0.074083,0 -0.2010833,0.0317 -0.2010833,0.15875 0,1.05833 -0.8255,2.23308 -1.0795,2.58233 l -0.052917,0.0741 c 0,0.0106 -0.010583,0.0106 -0.010583,0.0212 -0.010583,0.0317 -0.021167,0.0741 -0.021167,0.0952 0,0.0847 0.0635,0.14817 0.1693333,0.14817 h 1.5769166 v 0.52916 c 0,0.23284 -0.1905,0.29634 -0.3386667,0.29634 -0.1375833,0 -0.2010833,0.0741 -0.2010833,0.15875 0,0.0847 0.042333,0.17991 0.1693333,0.17991 h 1.7991667 c 0.084667,0 0.1693333,-0.0635 0.1693333,-0.17991 0,-0.11642 -0.1058333,-0.16934 -0.1905,-0.16934 -0.084667,0 -0.254,-0.0529 -0.254,-0.3175 V 210.6401 H 5.006037 c 0.084667,0 0.127,-0.0635 0.127,-0.16934 0,-0.0952 -0.03175,-0.15875 -0.127,-0.15875 z",
    style: {
      strokeWidth: 2.38434362
    },
    id: "path4550"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTs44);
export default __webpack_public_path__ + "static/media/ts-4-4.38f25019006b072909e3221535ae5fba.svg";
export { ForwardRef as ReactComponent };